import { render, staticRenderFns } from "./BulkActionActions.vue?vue&type=template&id=b60f377e&scoped=true&"
import script from "./BulkActionActions.vue?vue&type=script&lang=ts&"
export * from "./BulkActionActions.vue?vue&type=script&lang=ts&"
import style0 from "./BulkActionActions.vue?vue&type=style&index=0&id=b60f377e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60f377e",
  null
  
)

export default component.exports